import { render, staticRenderFns } from "./LetterContainerComponent.vue?vue&type=template&id=02223aab&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02223aab')) {
      api.createRecord('02223aab', component.options)
    } else {
      api.reload('02223aab', component.options)
    }
    module.hot.accept("./LetterContainerComponent.vue?vue&type=template&id=02223aab&", function () {
      api.rerender('02223aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Letter/LetterContainerComponent.vue"
export default component.exports